import React from 'react';

import { CompareByFile } from 'root/apps/ModuleCompareUI/components/CompareByFile';
import { CompareByID } from 'root/apps/ModuleCompareUI/components/CompareByID';
import { ModuleDifferenceRenderer } from 'root/apps/ModuleCompareUI/components/ModuleDifferenceRenderer';
import { useModuleCompare } from 'root/apps/ModuleCompareUI/context/Context';

const ModuleCompare: React.FC = () => {
  const {
    accountId,
    state: { comparedModules, secondAccountId, activeMode },
  } = useModuleCompare();

  return (
    <>
      <CompareByID />
      <CompareByFile />

      {comparedModules && secondAccountId && (
        <ModuleDifferenceRenderer
          modules={comparedModules}
          accountId={accountId}
          secondAccountId={secondAccountId}
          fromAccountEditable={true}
          toAccountEditable={activeMode === 'byId'}
        />
      )}
    </>
  );
};
export default ModuleCompare;
